// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1W2oX","container":"styles_container__2oPaW","title":"styles_title__2hBWn","wrapper":"styles_wrapper__19MvF","answer":"styles_answer__cGMrS"};